<style lang="scss">
#debug {
  display: none;
}
#frontend {
}
</style>

<template>
  <!--
  <HeaderIntroBoxBrands :style="{ 'background-image': `url(${require('@/assets/img/marketplaces/marketplaces-startbild-v2.jpg')})` }"  headerImageText="WILLHABEN">
  -->
  <SocialMediaIconBox />
  <BrandsBoxMarketplaces
    :brandImgLogo="require('@/assets/img/marken/brands/cope-group.svg')"
    brandAltText="Cope - Content Performance Group"
    brandHeadline="Cope - Content Performance Group"
    :brandLongText="$t('cope.txt')"
    brandGruendung="2020"
    brandWebsite="https://www.copegroup.com"
    brandWebsiteText="www.copegroup.com"

  />
  <MarkenBoxen />
  <Footer />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import SocialMediaIconBox from '../../../components/Frontend/SocialMediaIconBox.vue';
import HeaderIntroBoxBrands from '../../../components/Frontend/Brands/HeaderIntroBoxBrands.vue';
import BrandsBoxMarketplaces from '../../../components/Frontend/Brands/BrandsBoxMarketplaces.vue';
import MarkenBoxen from '../../../components/Frontend/MarkenBoxen.vue';
import Footer from '../../../components/Frontend/Footer.vue';

export default defineComponent({
  meta: {
    de: {
      title: 'Unsere Media-Brands | Styria Media Group',
      keywords: ['medien-marken', 'media-brands' , 'kleine zeitung' , 'antenne steiermark' , 'die presse' , 'cope' , 'styria' , 'styria media group'],
      description: 'Von der Printzeitung über das Newsportal bis hin zur Content- und Performance-Agentur: Wir informieren. Wir unterhalten. Wir vernetzen.',
      image: require('@/assets/img/og/brands.png'),
    },
    en: {
      title: 'Our media brands | Styria Media Group.',
      keywords: ['medien-brands', 'media-brands' , 'kleine zeitung' , 'antenne steiermark' , 'die presse' , 'cope' , 'styria' , 'styria media group'],
      description: 'From the print newspaper to the news portal to the content and performance agency: We inform. We entertain. We network.',
      image: require('@/assets/img/og/brands.png'),
    },
  },
  components: {
    SocialMediaIconBox,
    //HeaderIntroBoxBrands,
    MarkenBoxen,
    BrandsBoxMarketplaces,
    Footer,
  },
  setup() {


    return {
     
    };
  },
});
</script>
